import { Box, Paper, Typography } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";

interface LeadsByBrandChartProps {
  data: LeadsManagementData;
}

export default function LeadsByBrandChart({ data }: LeadsByBrandChartProps) {
  const { aggregations, goToFilteredLeads } = data;

  // Clicking a row opens the Leads tab with that brand in its Brand Name
  // filter.
  const breakdown = aggregations.byBrand
    .map((item) => ({ brandUid: item.brandUid, brand: item.brandName, count: item.count }))
    .sort((a, b) => b.count - a.count);
  const maxCount = Math.max(1, ...breakdown.map((row) => row.count));
  const totalLeads = breakdown.reduce((sum, row) => sum + row.count, 0);

  return (
    <Paper variant="outlined" data-tracker="939" sx={{ mt: 2.5, p: "16px 16px 32px 16px", borderRadius: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2.25 }}>
        <Typography sx={{ flex: 1, fontSize: 18, fontWeight: 500, color: "#1a1a1a" }}>
          Leads by Brand
        </Typography>
        <Typography sx={{ fontSize: 13, color: "#9e9e9e", marginRight: 7 }}>
          Total Leads:{" "}
          <Typography
            component="span"
            sx={{
              fontFamily: "Roboto",
              fontWeight: 500,
              fontSize: 14,
              lineHeight: "157%",
              letterSpacing: "0.1px",
              verticalAlign: "middle",
              color: "text.primary",
              marginLeft: 0.5,
            }}
          >
            {totalLeads}
          </Typography>
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        {breakdown.map((row) => (
          <Box
            key={row.brandUid}
            onClick={() => goToFilteredLeads({ brand: row.brandUid })}
            title="View these leads"
            sx={{ display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer" }}
          >
            <Typography
              sx={{
                width: 150,
                fontFamily: "Roboto",
                fontWeight: 400,
                fontSize: 14,
                lineHeight: "22px",
                letterSpacing: "0.17px",
                color: "text.secondary",
                textAlign: "right",
              }}
            >
              {row.brand}
            </Typography>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#9C27B014",
                borderRadius: "2px",
                height: 28,
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  borderRadius: "2px",
                  bgcolor: "secondary.dark",
                  width: `${Math.round((row.count / maxCount) * 100)}%`,
                }}
              />
            </Box>
            <Typography
              sx={{
                minWidth: 74,
                fontFamily: "Roboto",
                fontWeight: 500,
                fontSize: 14,
                lineHeight: "22px",
                letterSpacing: "0.1px",
                color: "secondary.main",
              }}
            >
              {row.count}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
